<template>
  <div class="modal-parent">
    <div class="gala">
      <main class="gala-container">
        <!-- BANNER -->
      <div class="gala-banner" data-v-b983b090="">
        <div class="gala-banner-content">
            <img src="../../assets/fiebre-canto/images/fdc26_logo.png" alt="Banner Logo" class="gala-banner-logo" data-v-b983b090="">
            <h4 class="text-white mb-0 banner-monto">PARTICIPA POR $1.000.000</h4>
            <small class="text-white">Elije tu participante</small>
            <br>
            <a href="https://www.chilevision.cl/concursos/bases-del-concurso-fiebre-de-canto/" target="_blank" rel="noopener noreferrer" class="text-white" style="text-decoration: underline;">Base del concurso</a>
            <div class="gala-banner-betano">
              <img src="../../assets/fiebre-canto/images/fdc26_betano.png" alt="Logo Betano" />
            </div>
        </div>
    </div>
        <!-- GRILLA -->
        <div :class="['gala-grid', { 'gala-grid-con-grupos': hayGrupos }]">
          <!-- una celda por solista o por grupo (dupla/trio/etc). Sin grupos, la celda
               es transparente (display:contents) y la grilla queda igual que siempre. -->
          <div v-for="celda in celdas" :key="celda.key"
               :class="celda.esGrupo ? 'gala-grupo' : 'gala-celda-solo'">
            <p v-if="celda.esGrupo" class="gala-grupo-titulo">{{ celda.titulo }}</p>
            <div :class="celda.esGrupo ? 'gala-grupo-items' : 'gala-celda-solo'">
              <div class="gala-grid-item" v-for="item in celda.integrantes" :key="item.participantesGeneralId">
                <img srcset="" :src="item.imageLink" alt="Foto de Miss" class="img-fluid cursor-pointer" @click="sendDataForModal(item.nombre)" />
                <div class="pb-5">
                    <p>{{ item.nombre.replace('Opcion', '') }}</p>
                </div>
                <div class="gala-grid-item-alias">
                  <!-- <h2>{{ item.alias }}</h2> -->
                  <div class="gala-grid-item-button">
                    <button @click="sendDataForModal(item.nombre)">VOTAR</button>
                  </div>
                  <p>{{ item.nombre }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <div>
          <p>Desarrollado por</p>
          <a href="mailto:contacto@celcom.cl" target="_blank">
            <img src="../../assets/galeria/logo_celcom_blanco.svg" alt="Logo Celcomlatam blanco"/>
          </a>
        </div>
      </footer>
      <div class="row justify-content-center">
        <div class="col-xl-8 text-center p-0">
          <div v-if="jsonData && !hayParticipantesActivos" class="got-votacion justify-content-center text-white text-uppercase">
            <h1 class="py-5 display-1">¡Votaciones Cerradas!</h1>
          </div>
          <div v-else class="gh-votacion justify-content-center text-white text-uppercase"/>
        </div>
      </div>
    </div>
    <ModalVotacionFiebreDeCanto
      v-if="modaIsActive"
      :dataForVotes="dataForVotes"
      :modaIsActive="modaIsActive"
      @changeModalIsActive="changeModalIsActive"
    />
    <LoaderComponent v-if="loaderIsActive"/>
  </div>
</template>

<script>
import ModalVotacionFiebreDeCanto from "./ModalVotacionFiebreDeCanto.vue";
import axios from "axios";
import { logout } from '@/auth.js';
import LoaderComponent from "../LoaderComponent/LoaderComponent.vue";

export default {
  name: 'FiebreDeCantoView',
  components: {
    ModalVotacionFiebreDeCanto,
    LoaderComponent
  },
  data() {
    return {
      jsonData: null,
      dataForVotes: {},
      modaIsActive: false,
      loaderIsActive: true,
    };
  },
  computed: {
    hayParticipantesActivos() {
      return this.jsonData.some(item => item.active);
    },
    // Agrupa por grupoId lo que estampa el backend con la placa vigente.
    // grupoId en null = participante suelto -> celda transparente, layout de siempre.
    // Los grupos van primero, en el orden de la placa (grupoId); los solistas
    // despues, en el orden alfabetico que ya traia jsonData.
    hayGrupos() {
      return (this.jsonData || []).some((item) => item.grupoId !== null && item.grupoId !== undefined);
    },
    celdas() {
      const filas = this.jsonData || [];
      const grupos = new Map();
      const solistas = [];

      filas.forEach((item) => {
        if (item.grupoId === null || item.grupoId === undefined) {
          solistas.push(item);
          return;
        }
        if (!grupos.has(item.grupoId)) {
          grupos.set(item.grupoId, {
            esGrupo: true,
            key: 'g' + item.grupoId,
            titulo: item.grupoNombre || item.grupoEtiqueta || '',
            integrantes: [],
          });
        }
        grupos.get(item.grupoId).integrantes.push(item);
      });

      const celdasGrupo = Array.from(grupos.keys())
        .sort((a, b) => a - b)
        .map((k) => grupos.get(k));

      const celdasSolo = solistas.map((item) => ({
        esGrupo: false,
        key: 's' + item.participantesGeneralId,
        integrantes: [item],
      }));

      return celdasGrupo.concat(celdasSolo);
    },
  },
  methods: {
    sendDataForModal(name){
      this.dataForVotes = {};
      this.modaIsActive = true;
      setTimeout(() => {
        const selectedItem = this.jsonData.find(item => item.nombre === name);
        this.dataForVotes = selectedItem;
      }, 10);
    },
    async cargarData() {
      // Endpoint propio de Fiebre de Canto (lp/5). Mantiene la categoria "FIEBRE".
      await axios.get("https://automata2.celcom.cl/lp_tvi_backend/api/notification/participantes_general/lp/5")
        .then(response => {
          this.jsonData = response.data.filter(item => item.active && item.category === "FIEBRE")
                .sort((a, b) => a.nombre.localeCompare(b.nombre));
        })
        .finally(() => {
          this.loaderIsActive = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeModalIsActive(value) {
      this.modaIsActive = value;
    },
  },
  created() {
    logout();
  },
  async mounted() {
    await this.cargarData();
    if (this.$route.params.name) {
      this.sendDataForModal(this.$route.params.name);
    }
  },
}
</script>
<style scoped lang="scss">
@font-face {
  font-family: 'avenir-regular';
  src: url('../../assets/fiebre-canto/fonts/SourceSansPro-Regular.ttf');
}

@font-face {
  font-family: 'avenir-bold';
  src: url('../../assets/fiebre-canto/fonts/SourceSansPro-Black.ttf');
}

.text-gold-miss {
    color: #B49B57;
}

.gala-banner-content {
    text-align: center;
    padding: 40px 0;
}
.gala-banner-logo {
    position: initial;
    width: 360px;
    max-width: 92%;
}
.banner-monto {
    font-family: 'avenir-bold';
    text-shadow: 0 2px 6px rgba(0, 0, 0, .9), 0 0 14px rgba(0, 0, 0, .7);
}
.gala-banner-betano {
    margin-top: 14px;

    img {
      width: 150px;
      max-width: 60%;
      border-radius: 6px;
    }
}
.text-green-miss {
    color: #0DB7B2;
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
}
.gala{
  background-image: url('../../assets/fiebre-canto/images/fdc26_back.jpg');
  background-position: top center;
  background-size: 100% clamp(340px, 58vw, 470px);
  background-repeat: no-repeat;
  background-color: #070b3a;
  font-family: 'avenir-regular';
  min-height: 100vh;
  padding-bottom: 110px;
  position: relative;

  p{
    margin: 0;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  &-banner{
    position: relative;

    &-logo{
      top: 50%;
      left: 50%;
      width: 360px;
      max-width: 92%;
    }

    &-text{
      background-color: #000;
      color: #FFF;
      text-align: center;
      padding: 8px 16px;
      font-size: 14px;
    }
  }

  footer{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    color: #FFF;
    padding: 8px 0;
    font-size: 14px;
    text-align: center;

    a{
      text-decoration: underline;
    }

    div{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      a{
        text-decoration: none;

        img{
          margin-top: -4px;
          width: 70px;
        }
      }
    }
  }
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
    .gala{
      background-image: url("../../assets/fiebre-canto/images/fdc26_back.jpg");
      background-position: top center;
      background-size: 100% 390px;
      background-repeat: no-repeat;
      padding-bottom: 80px;
    }
}
.gala-container {
  width: 100%;
  margin: 0 auto;

  // Tamaño por defecto (Mobile)
  max-width: 480px;

  // Tablet
  @media (min-width: 481px) {
    max-width: 640px;
  }

  // Desktop
  @media (min-width: 1024px) {
    max-width: 960px;
  }
}

// La celda de un solista no dibuja caja: su tarjeta queda como hijo directo
// de la grilla, exactamente como antes de existir la agrupacion.
.gala-celda-solo {
  display: contents;
}

// Cuadro que encierra a los integrantes de una dupla/trio/grupo.
// Ocupa la fila completa y adentro reparte a los integrantes, asi sirve
// para 2, 3 o mas sin depender del breakpoint.
.gala-grupo {
  // dos cuadros por fila, uno frente al otro: en mobile la grilla tiene 2
  // columnas y cada cuadro toma una; de 481 para arriba toma dos de cuatro.
  grid-column: span 1;
  padding: 10px;
  border: 2px solid rgba(64, 156, 255, 0.45);
  border-radius: 10px;
  background: rgba(44, 43, 94, 0.35);

  &-titulo {
    margin: 0 0 8px;
    text-align: center;
    font-family: 'avenir-bold';
    font-size: 14px;
    line-height: 1.25;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #FFF;

    // altura reservada de dos lineas: si un nombre es mas largo que el otro,
    // los cuadros de al lado siguen arrancando sus fotos a la misma altura.
    // Mas de dos lineas se recorta con puntos suspensivos.
    min-height: 2.5em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &-items {
    // los integrantes van uno debajo del otro dentro del cuadro
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(0, 260px);
    justify-content: center;
  }

  @media (min-width: 481px) {
    grid-column: span 2;
  }
}

// con grupos en pantalla el desktop pasa a 4 columnas: asi los cuadros
// (que ocupan 2) entran exactos de a dos por fila, sin dejar hueco.
// Doble clase a proposito: .gala-grid define sus columnas mas abajo en la
// hoja y con una sola clase le ganaria por orden.
.gala-grid.gala-grid-con-grupos {
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.gala-grid {
  padding: 16px;
  display: grid;
  gap: 16px;

  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 481px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  &-item{
    position: relative;
    padding: 8px;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;


    p{
      font-size: 14px;
      color: #FFF;
    }

    &-number{
      position: absolute;
      top: 60%;
      right: -20px;
      transform: translateY(-50%);
      width: 80px;
      height: 80px;
      border: 10px solid rgba(90, 47, 126, 0.1);
      border-radius: 50%;
      z-index: 0;

      p{
        font-family: 'avenir-bold';
      color: rgba(90, 47, 126, 0.1);
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      }
    }

    &-alias{
      text-align: center;
      width: 100%;

      h2{
        font-size: 16px;
        font-family: 'avenir-bold';
        color: #FFF;
        margin-bottom: 12px;
      }

      p{
        margin-bottom: 4px;
        font-size: 12px;
        color: #FFF;
      }
    }

    &-button{
      position: relative;
      margin-top: 4px;
      text-align: center;

      button{
        outline: none;
        border: none;
        border-radius: 12px;
        background: linear-gradient(45deg, #ff9800, #ff5722); /* Tonos cálidos del logo */
        font-size: 14px;
        font-weight: bold;
        color: #FFF;
        padding: 6px 16px;
        letter-spacing: 0.5px;
        width: 100%;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4); /* Resaltado */
        margin-bottom: 8px;
      }
    }
  }
}
.gala-grid-item-button button {
    outline: none;
    border: none;
    border-radius: 12px;
    background: linear-gradient(45deg, #E8D7EC, #6577BA);
    font-size: 14px;
    font-weight: 700;
    color: #131E29;
    padding: 6px 16px;
    letter-spacing: .5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 12px #E8D7EC66;
    margin-bottom: 8px;
}

.gala-grid-item-alias {
    text-align: center;
    width: 100%;
    padding: 5px 10px;
    position: absolute;
    bottom: 0;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
}
.gala-grid-item {
    position: relative;
    padding: 0px;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
    box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
}
.gala-grid-item > img {
    width: 100%;
    height: 260px;
    object-fit: cover;
    object-position: center top;
    display: block;
}
.gala-grid-item > .pb-5 {
    display: none;
}
.modal-parent{
  overflow: hidden;
}
.gala-grid-item .gala-grid-item-alias {
    background-image: linear-gradient(45deg,#061733,#1d1d77);
}

.gala-grid-item .gala-grid-item-button button {
    background: linear-gradient(45deg,#002773 ,#009ffc);
    color: #FFF;
    font-family: 'avenir-bold';
    font-weight: 700;
    box-shadow: 0 4px 12px #bebebf66;
}
.gala-chv-logo {
    display: block;
    margin: 0 auto;
    padding: 30px;
    width: 250px;
}
</style>
